import {
  AccessibilityAction,
  AccessibilityState,
} from '../../types/accessibility/accessibility.types';

import {
  DEFAULT_FONT_SCALE,
  FONT_SCALE_STEP,
  MAX_FONT_SCALE,
  MIN_FONT_SCALE,
} from '../../constants/accessibility/accessibility.constants';

export const accessibilityInitialState: AccessibilityState = {
  highContrast: false,
  fontScale: DEFAULT_FONT_SCALE,
  keyboardNavigation: true,
  screenReader: true,
  readerMode: false,
};

export function accessibilityReducer(
  state: AccessibilityState,
  action: AccessibilityAction
): AccessibilityState {
  switch (action.type) {
    case 'TOGGLE_HIGH_CONTRAST':
      return {
        ...state,
        highContrast: !state.highContrast,
      };

    case 'INCREASE_FONT':
      return {
        ...state,
        fontScale: Math.min(
          state.fontScale + FONT_SCALE_STEP,
          MAX_FONT_SCALE
        ),
      };

    case 'DECREASE_FONT':
      return {
        ...state,
        fontScale: Math.max(
          state.fontScale - FONT_SCALE_STEP,
          MIN_FONT_SCALE
        ),
      };

    case 'RESET_FONT':
      return {
        ...state,
        fontScale: DEFAULT_FONT_SCALE,
      };

    case 'TOGGLE_KEYBOARD_NAVIGATION':
      return {
        ...state,
        keyboardNavigation: !state.keyboardNavigation,
      };

    case 'TOGGLE_SCREEN_READER':
      return {
        ...state,
        screenReader: !state.screenReader,
      };

    case 'TOGGLE_READER_MODE':
      return {
        ...state,
        readerMode: !state.readerMode,
      };

    default:
      return state;
  }
}